export const FileSidebarSearch = {
  extends: 'CanvasSearch',
  position: 'relative',
  zIndex: 'none',
  theme: 'field',
  round: 'radiusPill',
  Form: {
    Icon: {
      top: 'Z1',
      name: 'search outline',
      position: 'absolute',
      left: 'Z2'
    },
    Input: {
      theme: 'field',
      round: 'radiusPill',
      padding: 'Z B2 Z B2+X2',
      placeholder: (el) => el.call('polyglot', 'common.action.filter')
    }
  },
  NavbarButton: {
    opacity: '0',
    position: 'absolute',
    top: 'X',
    right: 'X',
    theme: 'transparent',
    // eslint-disable-next-line no-restricted-syntax -- icon-only clear button (aria-labelled), not text
    color: 'inactive',
    icon: 'crossmark',
    ariaLabel: (el) => el.call('polyglot', 'editor.sidebar.clearSearch'),
    fontSize: 'Z2',
    ':hover': {
      opacity: '1',
      color: 'title'
    },
    onClick: (ev, el) => {
      const { node } = el.parent.Form.Input
      if (node.value) {
        // LOOKUP-SHAPE-1: threw inline on a miss — guarded so the input
        // still clears/refocuses even when the sidebar isn't mounted.
        el.lookup('CanvasProjectSidebar')?.state?.update({
          search: ''
        })
        node.value = ''
        setTimeout(() => {
          node.focus()
        }, 100)
      }
    }
  }
}
